export default "__VITE_ASSET__06fee54a__"